import { useState } from "react";
import { Link, useNavigate, useSearchParams, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, GoogleButton, Divider } from "@/components/AuthBits";

const FIELDS = [
  ["name", "Seu nome", "text", "name"],
  ["email", "E-mail", "email", "email"],
  ["whatsapp", "WhatsApp", "tel", "tel"],
  ["password", "Senha (mínimo 8 caracteres)", "password", "new-password"],
];

export default function Register() {
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/perfil";
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", whatsapp: "", password: "" });
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={next} replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!agree) return toast.error("Aceite os termos de uso e a política de privacidade.");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data);
      toast.success("Conta criada!");
      navigate(next, { replace: true });
    } catch (err) {
      toast.error(errMsg(err));
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Criar conta" subtitle="Uma conta só para pedir serviços e, se quiser, trabalhar como prestador." backTo="/" forceBack>
      <GoogleButton next={next} />
      <Divider />
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        {FIELDS.map(([k, label, type, ac]) => (
          <div key={k}>
            <label className="po-label" htmlFor={`reg-${k}`}>{label}</label>
            <input id={`reg-${k}`} type={type} autoComplete={ac} required={k !== "whatsapp"} minLength={k === "password" ? 8 : undefined}
              className="po-input" value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`register-${k}-input`} />
          </div>
        ))}
        <label className="flex items-start gap-3 text-base text-slate-700">
          <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} className="mt-1 h-6 w-6 accent-orange-500" data-testid="register-terms-checkbox" />
          <span>Li e aceito os <Link to="/termos" className="font-semibold text-orange-600 underline">Termos de uso</Link> e a <Link to="/privacidade" className="font-semibold text-orange-600 underline">Política de privacidade</Link>.</span>
        </label>
        <button type="submit" disabled={busy} className="po-btn-primary w-full" data-testid="register-submit-button">
          {busy && <Loader2 className="h-6 w-6 animate-spin" />} Criar conta
        </button>
      </form>
      <p className="mt-5 text-lg">Já tem conta? <Link to={`/entrar?next=${encodeURIComponent(next)}`} className="font-semibold text-orange-600 underline">Entrar</Link></p>
    </AuthShell>
  );
}
